import { render, staticRenderFns } from "./AdminReportsAttendanceMenuStudent.vue?vue&type=template&id=501f2bc4"
import script from "./AdminReportsAttendanceMenuStudent.vue?vue&type=script&lang=js"
export * from "./AdminReportsAttendanceMenuStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports